"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAccessibleForeground = useAccessibleForeground;
var _react = require("react");
var _getAccessibleForeground = require("@cbhq/cds-common/color/getAccessibleForeground");
var _usePaletteConfig2 = require("@cbhq/cds-common/palette/usePaletteConfig");
var _usePaletteValueToRgbaString = require("./usePaletteValueToRgbaString");
/** See http://cds.cbhq.net/hooks/useAccessibleForeground for details and examples. */

function useAccessibleForeground(params) {
  const _usePaletteConfig = (0, _usePaletteConfig2.usePaletteConfig)(),
    paletteBackground = _usePaletteConfig.background;
  const backgroundFromPalette = (0, _usePaletteValueToRgbaString.usePaletteValueToRgbaString)(paletteBackground);
  const transformFn = (0, _usePaletteValueToRgbaString.usePaletteValueToRgbaString)();
  const convert = (0, _react.useCallback)(({
    background,
    color,
    usage,
    enhanced
  }) => (0, _getAccessibleForeground.getAccessibleForeground)(background !== null && background !== void 0 ? background : backgroundFromPalette, color, usage, transformFn, enhanced), [backgroundFromPalette, transformFn]);
  return (0, _react.useMemo)(() => {
    if (params) {
      return convert(params);
    }
    return convert;
  }, [convert, params]);
}